import ThreeDot from "@/assets/icons/threeDot.svg";
import GrayFileIcon from "@/assets/icons/GrayFileIcon.svg";
import FileIcon from "@/assets/icons/FileIcon.svg";
import { handleDownload } from "@/utils/handleDownload";
import { FileDetails } from "@/types/projectType";
import Check from "@/assets/icons/GreenCheck.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/Dropdrown";
import { formatFileSize } from "@/utils/formatFileSize";

type RevisionFileCardProps = {
  comment: string;
  file: FileDetails;
  active: boolean;
  isApproved?: boolean;
  requiresRevision?: boolean;
  showRequestRevisionForm?: boolean;
  isLoading?: boolean;
  onRequestRevision?: () => void;
  onApprove?: () => void;
};

export const RevisionFileCard = ({
  file,
  active,
  isApproved,
  showRequestRevisionForm,
  isLoading,
  onRequestRevision,
  comment,
  onApprove,
}: RevisionFileCardProps) => {
  return (
    <div className="mt-3 mb-4 p-4 border-[1.5px] border-[#F0EEEE] w-full rounded-xl">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          {active ? <FileIcon /> : <GrayFileIcon />}
          <div>
            <h6 className="text-xs text-black font-medium">{file?.name}</h6>
            <p className="text-[11px] text-[#959FB2]">
              {formatFileSize(file?.size)}
            </p>
          </div>
        </div>
        <div className="hidden relative lg:flex gap-4 items-center">
          {isApproved && (
            <p className="text-xs font-medium flex items-center px-2 py-1 rounded-full gap-x-1 bg-[#E9F5EF] text-[#1D7100]">
              Approved
            </p>
          )}
          <DropdownMenu>
            <DropdownMenuTrigger>
              <button>
                <ThreeDot />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem>
                <p className="text-caption-large font-semibold text-gray-800">
                  Report
                </p>
              </DropdownMenuItem>
              <DropdownMenuItem>
                <p
                  onClick={() =>
                    handleDownload(file?.live_url as string, file?.name)
                  }
                  className="text-caption-large font-semibold text-gray-800"
                >
                  Download
                </p>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      {/* {!isApproved && (
        <div className="block lg:hidden gap-3 justify-between items-center mt-5">
          {!showRequestRevisionForm && (
            <button
              onClick={onRequestRevision}
              className="text-[#475467] text-[11px] sm:text-xs font-medium whitespace-nowrap"
            >
              Request revision
            </button>
          )}
          <button
            onClick={onApprove}
            className="flex items-center gap-1 md:gap-2 text-[#1D7100] text-[10px] sm:text-xs tracking-[-0.75] leading-4 py-1 px-2 bg-[#E9F5EF] border border-[#1D7100] rounded-xl"
          >
            <Check />
            <p>{isLoading ? "Approving" : "Approve it"}</p>
          </button>
        </div>
      )} */}
      <div className="p-3  mt-4 bg-[#F1F1F1] rounded-[10px] border-[#F1F1F1] border">
        <p className="text-[#667085]  text-caption-large">{comment}</p>
      </div>
    </div>
  );
};
